"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerWrapper = exports.TextWrapper = exports.OfferNotificationSubscriptionStepWrapper = void 0;
const styled_breakpoints_1 = require("styled-breakpoints");
const styled_components_1 = __importDefault(require("styled-components"));
exports.OfferNotificationSubscriptionStepWrapper = styled_components_1.default.div `
	width: 100%;
	max-width: 700px;
`;
exports.TextWrapper = styled_components_1.default.div `
	font-size: 1.2rem;
	text-align: center;
	margin: 2rem 0;
	color: ${props => props.theme.color.gray6};

	${(0, styled_breakpoints_1.down)('sm')} {
		margin: 0 0 1rem;
	}
`;
exports.SpinnerWrapper = styled_components_1.default.div `
	text-align: center;
	margin: 6rem 0;
`;
